import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67c7c2a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "col-form-label fw-bold mb-2" }
const _hoisted_3 = { class: "rounded-3 bg-search p-4 mb-3" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "row mx-4" }
const _hoisted_6 = { class: "row w-100 mb-4 pb-4 border-bottom px-0" }
const _hoisted_7 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = ["placeholder", "maxlength"]
const _hoisted_10 = { class: "row w-100 mb-4 pb-4 border-bottom px-0" }
const _hoisted_11 = { class: "col-lg-2 col-form-label margin-left pe-0" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = ["placeholder", "maxlength"]
const _hoisted_14 = { class: "row w-100 mb-4 pb-4 border-bottom px-0" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 margin-left pe-0" }, null, -1))
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = { class: "form-check" }
const _hoisted_18 = ["for"]
const _hoisted_19 = ["id"]
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = ["for"]
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "d-flex justify-content-center mb-5" }
const _hoisted_24 = { class: "d-flex justify-content-end mb-3" }
const _hoisted_25 = { class: "d-lg-flex" }
const _hoisted_26 = { class: "d-flex align-items-center ms-3" }
const _hoisted_27 = { class: "text-black fs-7" }
const _hoisted_28 = {
  key: 0,
  class: "ms-1 badge bg-green"
}
const _hoisted_29 = { class: "w-25" }
const _hoisted_30 = {
  key: 0,
  class: "d-flex fw-bold align-items-center fs-7"
}
const _hoisted_31 = {
  key: 1,
  class: "d-flex fw-bold align-items-center fs-7"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: /*#__PURE__*/_normalizeClass(['cursor-pointer'])
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen color-edit" })
], -1))
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-danger" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_37 = {
  key: 1,
  class: "text-center fw-bold"
}
const _hoisted_38 = { class: "mt-3 d-flex" }
const _hoisted_39 = { class: "d-flex align-items-center ms-3" }

import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Loading from '@/components/loading/index.vue'
import { ReplayName, numberWithCommas } from '@/constants/common'
import groupsService from '@/services/groups.service'

import ModalDelete from './components/ModalDelete.vue'
import ModalEdit from './components/ModalEdit.vue'
import ModalEditAlumnus from './components/ModalEditAlumnus.vue'
import ModalCreate from './components/ModalCreate.vue'
import Button from '@/components/button/index.vue'
import { watch, ref, computed, onMounted } from 'vue'
import { MAX_LENGTH_TITLE_SEARCH, MAX_LENGTH_USER_NAME_SEARCH } from '@/constants/number'
import { translate } from '@/languages/i18n'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Table from '@/components/table/index.vue'
import { GROUPS_STORE } from '@/store/constants'
import UserAliasIcon from '@/components/user-alias-icon'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import TotalRecords from '@/components/total-records/index.vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const route = useRoute()
const router = useRouter()
const sortField = ref('')

const currentData = ref('')
const groupName = ref('')
const dataDetail = ref({})

const data = computed(() => store.getters[GROUPS_STORE.GETTERS.LIST_GROUPS])
const loading = ref(false)

const modalEditGroup = ref()
const modalEditGroupAlumnus = ref()

const dataSearchInput = ref({
  name: '',
  created_name: '',
  publishedDefault: '',
  invitationGroupDefault: '',
})
const dataSearch = ref({
  keyword_name: '',
  keyword_created_name: '',
  published: '',
  invitation_group: '',
})
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('groupManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('listGroup'),
    to: '',
    active: true,
  },
]

const ReplayNameMessage = (is_deleted_in_30_days: string | number, available: boolean, family_name: string, given_name: string) => {
  if (is_deleted_in_30_days === 0) {
    if (!available) {
      return family_name + ' ' + given_name + ' ' + '[一時停止]'
    } else return family_name + ' ' + given_name
  } else if (is_deleted_in_30_days === 1) {
    return family_name + ' ' + given_name + ' ' + '[脱退済み]'
  } else if (is_deleted_in_30_days === 2) {
    return '脱退済みユーザ'
  } else {
    return family_name + ' ' + given_name
  }
}

onMounted(() => {
  if (Object.keys(route.query).length === 0) {
    router.push({ path: route.path, query: { created_at: 'desc' } })
  }
})

watch(
  () => route.query,
  () => {
    dataSearch.value = {
      keyword_name: route.query?.keyword_name || '',
      keyword_created_name: route.query?.keyword_created_name || '',
      published: route.query?.published ? '' : true,
      invitation_group: !route.query?.invitation_group ? '' : true,
    }
    dataSearchInput.value = {
      name: route.query?.keyword_name || '',
      created_name: route.query?.keyword_created_name || '',
      publishedDefault: !route.query?.published ? '' : true,
      invitationGroupDefault: !route.query?.invitation_group ? '' : true,
    }
  },
  {
    immediate: true,
  }
)
watch(
  () => route.query,
  async () => {
    if (route.path === `/community/communities/${route.params?.id}/admin/groups`) {
      loading.value = true
      await store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_GROUPS, {
        id: route.params?.id,
        params: {
          group_type: '3',
          ...route.query,
          ...dataSearch.value,
          page_of_number: route.query?.page_of_number || 30,
          create_by_admin: true,
        },
      })
      loading.value = false
    }
  },
  {
    immediate: true,
  }
)

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

const setCurrentData = async (id: any, name: string, action: string, user_type: any): void => {
  currentData.value = id
  groupName.value = name
  loading.value = true
  try {
    const data = {
      create_by_admin: true,
    }
    const response = await groupsService.getDetailGroupApi(id, data)
    if (response?.status === 200) {
      dataDetail.value = response?.data?.data?.group
    } else if (response?.response?.status === 404) {
      router.push('/404')
    }

    if (action === 'edit') {
      user_type === 3 ? modalEditGroup.value.show() : modalEditGroupAlumnus.value.show()
    }
    loading.value = false
  } catch (error) {
    console.log(error)
  }
}

const SearchKey = async () => {
  // 2022/09/15 CW-Phuong Fix for horizontal fixing#7: OC10
  if (checkRouter()) {
    loading.value = true
    if (route.path === `/community/communities/${route.params?.id}/admin/groups`) {
      loading.value = true
      await store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_GROUPS, {
        id: route.params?.id,
        params: {
          group_type: '3',
          ...route.query,
          ...dataSearch.value,
          page_of_number: route.query?.page_of_number || 30,
          create_by_admin: true,
        },
      })
      loading.value = false
    }
    return
  }

  dataSearch.value = {
    keyword_name: dataSearchInput.value.name,
    keyword_created_name: dataSearchInput.value.created_name,
    published: !dataSearchInput.value.publishedDefault ? '' : true,
    invitation_group: !dataSearchInput.value.invitationGroupDefault ? '' : true,
  }

  router.push({ path: route.path, query: { ...route.query, ...dataSearch.value, page_of_number: route.query?.page_of_number || 30 } })
}
// 2022/09/15 CW-Phuong Fix for horizontal fixing#7: OC10
const checkRouter = () => {
  let keyword_name_route = route.query?.keyword_name ?? ''
  let keyword_created_name_route = route.query?.keyword_created_name ?? ''
  let published_route = ''
  let invitation_group_route = ''
  if (route.query.published) published_route = true
  if (route.query.invitation_group) invitation_group_route = true
  if (
    dataSearchInput.value.name === keyword_name_route &&
    dataSearchInput.value.created_name === keyword_created_name_route &&
    dataSearchInput.value.publishedDefault === published_route &&
    dataSearchInput.value.invitationGroupDefault === invitation_group_route
  )
    return true
}

const hideModalEditGroup = (): void => {
  modalEditGroup.value.hide()
}

onMounted(() => {
  modalEditGroup.value = new Modal(document.getElementById('editGroup'))
  modalEditGroupAlumnus.value = new Modal(document.getElementById('editGroupAlumnus'))
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('listGroup')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(SearchKey, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(translate)('groupName')), 1),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: _unref(translate)('placeholder'),
                  maxlength: _unref(MAX_LENGTH_TITLE_SEARCH),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataSearchInput.value.name) = $event)),
                  class: "form-control"
                }, null, 8, _hoisted_9), [
                  [
                    _vModelText,
                    dataSearchInput.value.name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(translate)('creator')), 1),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: _unref(translate)('placeholder'),
                  maxlength: _unref(MAX_LENGTH_USER_NAME_SEARCH),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataSearchInput.value.created_name) = $event)),
                  class: "form-control"
                }, null, 8, _hoisted_13), [
                  [
                    _vModelText,
                    dataSearchInput.value.created_name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: _ctx.flexCheckDefault
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: " ",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dataSearchInput.value.publishedDefault) = $event)),
                      id: _ctx.flexCheckDefault
                    }, null, 8, _hoisted_19), [
                      [_vModelCheckbox, dataSearchInput.value.publishedDefault]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('privateGroup')), 1)
                  ], 8, _hoisted_18)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: _ctx.CheckinvitationGroupDefault
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: " ",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dataSearchInput.value.invitationGroupDefault) = $event)),
                      id: _ctx.CheckinvitationGroupDefault
                    }, null, 8, _hoisted_22), [
                      [_vModelCheckbox, dataSearchInput.value.invitationGroupDefault]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('invitationGroup')), 1)
                  ], 8, _hoisted_21)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(Button, {
              title: _unref(translate)('searchButton'),
              type: 'secondary',
              htmlType: 'submit'
            }, null, 8, ["title"])
          ])
        ], 40, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(ModalCreate)
      ]),
      _createVNode(TotalRecords, {
        totalRecords: _unref(data)?.total_records
      }, null, 8, ["totalRecords"]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(Pagination, {
          totalDataOfPage: _unref(data)?.data?.length,
          totalPage: _unref(data)?.total_pages
        }, null, 8, ["totalDataOfPage", "totalPage"]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ]),
      _createVNode(Table, {
        columns: [
        { field: 'name', name: _unref(translate)('groupName') },
        { field: 'management_no', name: _unref(translate)('managementNo'), sort: sortField.value === 'management_no' },
        { field: 'admin_name', name: _unref(translate)('creator'), sort: sortField.value === 'admin_name' },
        { field: 'total_alumni_users', name: _unref(translate)('almunaiNode'), sort: sortField.value === 'total_alumni_users', maxWidth: true },
        { field: 'total_employee_users', name: _unref(translate)('employeeUser'), sort: sortField.value === 'total_employee_users', maxWidth: true },
        { field: 'total_talkrooms', name: _unref(translate)('talkRoom'), sort: sortField.value === 'total_talkrooms', maxWidth: true },
        { field: 'created_at', name: _unref(translate)('registrationDate'), sort: sortField.value === 'created_at' },
        { field: 'updated_at', name: _unref(translate)('lastUpdateTime'), sort: sortField.value === 'updated_at' },
        { field: 'edit', name: _unref(translate)('edit'), maxWidth: true },
        { field: 'delete', name: _unref(translate)('delete'), maxWidth: true },
      ],
        sortCells: ['management_no', 'admin_name', 'total_alumni_users', 'total_employee_users', 'total_talkrooms', 'created_at', 'updated_at']
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data)?.data, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: _normalizeClass(['align-middle text-center', index % 2 === 0 && 'rowEven', !item?.published && 'bg-private']),
              key: index
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(item?.name), 1),
                (item?.invitation_group === true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(translate)('inviteOnlyGroup')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(item?.admin?.management_no), 1),
              _createElementVNode("td", _hoisted_29, [
                ([1, 2].includes(item?.admin?.user_type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createVNode(_unref(UserAliasIcon), {
                        userType: item?.admin?.user_type
                      }, null, 8, ["userType"]),
                      _createElementVNode("span", null, _toDisplayString(_unref(ReplayName)(item?.admin?.is_deleted_in_30_days, item?.admin?.available, item?.admin?.family_name, item?.admin?.given_name, item?.admin?.user_type)) + _toDisplayString(item?.admin?.user_type == 2 && [0, 1].includes(item?.admin?.is_deleted_in_30_days) ? `（ ${item?.admin?.display_name} ）` : ''), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item?.admin?.user_type === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createVNode(_unref(UserAliasIcon), {
                        userType: item?.admin?.user_type
                      }, null, 8, ["userType"]),
                      _createElementVNode("span", null, _toDisplayString(ReplayNameMessage(item?.admin?.is_deleted_in_30_days, item?.admin?.available, item?.admin?.family_name, item?.admin?.given_name)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params?.id}/alumnus?page=1&management_no=desc&group_id=${item?.id}`,
                  class: "text-black fs-8 cursor-pointer"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(numberWithCommas)(item?.total_alumni_users)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params?.id}/community-users?page=1&management_no=desc&group_id=${item?.id}`,
                  class: "text-black fs-8 cursor-pointer"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(numberWithCommas)(item?.total_employee_users)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params?.id}/admin/groups/${item.id}/talkrooms`,
                  class: "text-black fs-8 cursor-pointer"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(numberWithCommas)(item?.total_talkrooms)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", null, _toDisplayString(_unref(ConvertFromLocalTime)(item?.created_at)), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(ConvertFromLocalTime)(item?.updated_at)), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params?.id}/admin/groups/${item.id}/edit`
                }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: "cursor-pointer",
                  "data-bs-Toggle": "modal",
                  "data-bs-target": "#deleteGroupCommunity",
                  onClick: ($event: any) => (setCurrentData(item.id, item.name))
                }, _hoisted_35, 8, _hoisted_33)
              ])
            ], 2))
          }), 128))
        ]),
        _: 1
      }, 8, ["columns"]),
      (_unref(data)?.data?.length === 0 && (dataSearch.value.keyword_name || dataSearch.value.keyword_created_name) && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_unref(translate)('OC10noSearchData')), 1))
        : _createCommentVNode("", true),
      (_unref(data)?.data?.length === 0 && !dataSearch.value.keyword_name && !dataSearch.value.keyword_created_name && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(translate)('OC10noData')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(Pagination, {
          totalDataOfPage: _unref(data)?.data?.length,
          totalPage: _unref(data)?.total_pages
        }, null, 8, ["totalDataOfPage", "totalPage"]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ])
    ]),
    _createVNode(ModalDelete, {
      groupId: currentData.value,
      groupName: groupName.value,
      dataSearch: dataSearch.value
    }, null, 8, ["groupId", "groupName", "dataSearch"]),
    _createVNode(ModalEdit, {
      groupId: currentData.value,
      dataDetail: dataDetail.value,
      loading: loading.value,
      onHideModalEditGroup: hideModalEditGroup
    }, null, 8, ["groupId", "dataDetail", "loading"]),
    _createVNode(ModalEditAlumnus, {
      groupId: currentData.value,
      dataDetail: dataDetail.value,
      loading: loading.value
    }, null, 8, ["groupId", "dataDetail", "loading"]),
    _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})